import React, { Component, useState } from "react";
import { NavbarBrand, NavItem,  a,} from "reactstrap";
import { Link, useLocation, Redirect } from "react-router-dom";
import "./NavMenu.css"
import { useEffect } from "react";
import axios from "axios";
export const NavMenu = (props) => {
    let menu, menuSection, menuArrow, menuClosed, menuToggle, menuOverlay;
    const [isActive, setActive] = useState(false);
    const [route, setRoute] = useState("");
    const [IsLogin, setLogin] = useState(false);
    const [IsHideDash, setDeshBoard] = useState(false);
    const [IsHideWithAff, setHideWithAff] = useState(true);
    const [UserID, setUserID] = useState(0);
    const Location = useLocation();
    const [classVal, setClassVal] = useState("");
    const [UserData, setUserData] = useState("");
    useEffect(() => {
        setActive(false)
    }, [Location])


    useEffect(() => {

        let url = new URLSearchParams(window.location.search);

        if (url.has("user") || window.localStorage.getItem("token") !== null) {
            let Token = {
                token: url.get("user") !== null ? url.get("user") : JSON.parse(window.localStorage.getItem("token")).token
            }
            url.get("user") !== null && window.localStorage.setItem("token", JSON.stringify(Token));
            GetUserInfo(Token.token);
        }
    }, []);

    const GetUserInfo = () => {
        let Token = window.localStorage.getItem("token");
        if (Token != null) {
            // Token = JSON.parse(Token);

            let parseToken = false;
            if (Token.charAt(0) === "{")
                parseToken = true;

            let data = {
                Token: parseToken ? JSON.parse(Token).token : Token,
            };

            let md = {
                PostString: JSON.stringify(data)
            }
            axios.post("https://crmapi.smcinsurance.com:8081/api/User/GetUserInfo", data)
                .then((Res) => {
                    console.log(Res.data);
                    if (Res.data.userID !== undefined && Res.data.userID !== "Session is abort") {
                        setUserData(Res.data);
                        console.log("login success");
                        setUserID(Res.data?.userID);
                        setLogin(Res.data.userID > 0 ? true : false);
                        setHideWithAff(Res.data.user == 31852 ? true : false);
                        setDeshBoard(Res.data.roleID === 29 ? false : true);
                        Res.data.userID > 0 && window.sessionStorage.setItem("UserID", Res.data.userID);
                    } else window.localStorage.removeItem("token");
                });

        }
    };


    const [scroll, setScroll] = useState(false)
    useEffect(() => {
        if (window.innerWidth >= 768) {
            window.addEventListener("scroll", () => {
                setScroll(window.scrollY > 10)
            })
        }
    },
        []);
    useEffect(() => {
        let url = window.location.href;
        url = url.toLowerCase();

        if ((url.includes("/lp/investmentplan") || url.includes("/lp/investment-hdfc-plan") || url.includes("/lp/landingpage-thankyou") || url.includes("/lp/investment-bajaj-plan2") || url.includes("/lp/investment-bajaj-plan"))) {
            setClassVal("LandingPage");
        }
        if ((url.includes("/lp/investment-meeting-session"))) {
            setClassVal("LandingPage");


        }
        const dURL = window.location.pathname;
        setDeshBoard(dURL.toLowerCase() === "/investment");
    }, [])
    return (
        <React.Fragment>
            <header className={scroll ? `header scrolled ${classVal}` : `header ${classVal}`}>
                <nav className="navbar navbar-expand-lg navbar-light" aria-label="Offcanvas navbar large">
                    <div className="container-fluid d-block">
                        <div className="wrapper">
                            <div className="header-item-left">
                                <a className="navbar-brand" href="/">
                                    <img src="https://www.smcinsurance.com/img/smclogo.png" alt="logo" title="SMC Insurance" />
                                </a>
                            </div>

                            <div className="header-item-center">
                                <div className="offcanvas offcanvas-start text-bg-light" tabIndex="-1" id="offcanvasNavbar2" aria-labelledby="offcanvasNavbar2Label">
                                    <div className="offcanvas-header">
                                        <a className="navbar-brand" href="/">
                                            <img src="https://www.smcinsurance.com/img/smclogo.png" alt="logo" title="SMC Insurance" />
                                        </a>
                                        <button type="button" className="btn-close btn-close-black" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                                    </div>
                                    <div className="offcanvas-body">
                                        <ul class="navbar-nav flex-grow-1 pe-3" id="WithPrevilage">
                                            <li class="nav-item dropdown">
                                                <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    General Insurance <i class="fa fa-angle-down"></i>
                                                </a>
                                                <div class="menu-subs dropdown-menu menu-small">
                                                    <div class="OurProduct">
                                                        <ul>
                                                            <li itemprop="name">
                                                                <a itemprop="url" href="/motor-insurance">
                                                                    Motor Insurance
                                                                </a>
                                                            </li>

                                                            <li itemprop="name">
                                                                <a itemprop="url" href="/motor-insurance/car-insurance">
                                                                    Car Insurance
                                                                </a>
                                                            </li>
                                                            <li itemprop="name">
                                                                <a itemprop="url" href="/motor-insurance/two-wheeler-insurance">
                                                                    Two Wheeler Insurance
                                                                </a>
                                                            </li>
                                                            <li itemprop="name">
                                                                <a itemprop="url" href="/commercial-vehicle-insurance">
                                                                    Commecial Vehicle Insurance
                                                                </a>
                                                            </li>
                                                            <li itemprop="name">
                                                                <a itemprop="url" href="/motor-insurance/two-wheeler-insurance/e-bike-insurance">
                                                                    E-Bike Insurance
                                                                </a>
                                                            </li>
                                                            <li itemprop="name">
                                                                <a itemprop="url" href="/health-insurance">
                                                                    Health Insurance
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>

                                            <li class="nav-item dropdown">
                                                <a class="nav-link dropdown-toggle" href="javascript:void(0)" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    Life Insurance <i class="fa fa-angle-down"></i>
                                                </a>
                                                <div class="menu-subs dropdown-menu menu-small">
                                                    <div class="OurProduct">
                                                        <ul>
                                                            <li itemprop="name">
                                                                <a itemprop="url" href="/life-insurance">
                                                                    Life Insurance
                                                                </a>
                                                            </li>
                                                            <li itemprop="name">
                                                                <a itemprop="url" href="/life-insurance/term-insurance">
                                                                    Term Insurance
                                                                </a>
                                                            </li>
                                                            <li itemprop="name">
                                                                <a itemprop="url" href="/life-insurance/pension-plans">
                                                                    Pension Plans
                                                                </a>
                                                            </li>
                                                            <li itemprop="name">
                                                                <a itemprop="url" href="/life-insurance/whole-life-insurance">
                                                                    Whole Life Insurance
                                                                </a>
                                                            </li>
                                                            <li itemprop="name">
                                                                <a itemprop="url" href="/life-insurance/ulip-plans">
                                                                    Unit Linked Insurance Plan
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>

                                            <li class="nav-item dropdown">
                                                <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    Insurance Article <i class="fa fa-angle-down"></i>
                                                </a>
                                                <div class="menu-subs dropdown-menu menu-small">
                                                    <div class="OurProduct">
                                                        <ul>
                                                            <li itemprop="name">
                                                                <a itemprop="url" href="/articles">
                                                                    Articles
                                                                </a>
                                                            </li>
                                                            <li itemprop="name">
                                                                <a itemprop="url" href="/insurance-videos">
                                                                    Videos
                                                                </a>
                                                            </li>
                                                            <li itemprop="name">
                                                                <a itemprop="url" href="/magazine">
                                                                    Magazine
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>

                                        {UserID !== 31852 ?
                                            <ul class="navbar-nav justify-content-end flex-grow-1 pe-3" id="HideWithAFF">
                                                <li itemprop="name">
                                                    <a itemprop="url" href="/about" class="nav-link">
                                                        About Us
                                                    </a>
                                                </li>
                                                <li itemprop="name">
                                                    <a itemprop="url" href="/contact" class="nav-link">
                                                        Contact Us
                                                    </a>
                                                </li>
                                                <li itemprop="name" id="HideEndUser">
                                                    <a itemprop="url" href="/epartner" class="nav-link">
                                                        Become a Sales Partner
                                                    </a>
                                                </li>
                                                <li itemprop="name">
                                                    <a itemprop="url" href="/claims" class="nav-link">
                                                        Claim
                                                    </a>
                                                </li>
                                                <li itemprop="name">
                                                    <a itemprop="url" href="https://ha.smcinsurance.com/" rel="nofollow" target="_blank" class="nav-link">
                                                        SMC Assure
                                                    </a>
                                                </li>
                                            </ul>
                                            :
                                            null
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="header-item-right">
                                <ul className="SubHead_Risk">
                                    {IsHideDash ?
                                        <li>
                                            <button className={`SMCSmall  LoginBtn NotMobile ${IsLogin ? "DashboardBtn" : ""}`} onClick={() => window.location.href = "https://www.smcinsurance.com/myaccount"}>
                                                {!IsLogin ? "Login" : /*`${UserData.userName.trim().split(" ")[0]}`*/ "Dashboard"}
                                            </button>
                                            <button className={`SMCSmall  LoginBtn ForMobile ${IsLogin ? "DashboardBtn" : ""}`} onClick={() => window.location.href = "https://www.smcinsurance.com/myaccount"}>
                                                {IsLogin ? <i className="fas fa-user-circle"></i> : <i className="far fa-user-circle"></i>}
                                            </button>
                                        </li>
                                        :
                                        null

                                    }

                                </ul>
                                <button className="navbar-toggler MobileNavBTN" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar2" aria-controls="offcanvasNavbar2">
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </nav>
            </header>

        </React.Fragment>
    );
}


